import View from '../../View';

/**
 * ArticleComments
 */
class ArticleComments extends View {
    constructor(node) {
        super(node);

        this.textarea = this.node.querySelector('.js-article-comments-form-textarea');
        this.textareaError = this.node.querySelector('.js-article-comments-form-textarea-error');
        this.email = this.node.querySelector('.js-article-comments-form-email');
        this.emailError = this.node.querySelector('.js-article-comments-form-email-error');

        this.textarea.addEventListener('keyup', this.textareaChangeHandler);

        //Custom submit
        this.submitButton = this.node.querySelector('.js-article-comments-form-submit');
        this.submitButton.addEventListener('click', this.submitClickHandler);

        //Validate fields on submit
        this.node.addEventListener('submit', this.submitClickHandler);
    }

    textareaChangeHandler = () => {
        if(this.textarea.value.length >= 2000){
            this.toggleError('textarea', 'Het bericht kan helaas niet langer dan 2000 karakters zijn.')
        }
        else{
            this.toggleError('textarea', '');
        }
    };

    /**
     * Submit the form when the fake button has been pressed
     * @param e
     */
    submitClickHandler = (e) => {
        e.preventDefault();

        let errors = 0;

        //If the message is too short
        if(this.textarea.value.length < 5){
            errors++;
            this.toggleError('textarea', 'Vul a.u.b. een bericht in.');
        }
        else{
            this.toggleError('textarea', '');
        }

        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //If the email is too short
        if(this.email.value.length < 5){
            errors++;
            this.toggleError('email', 'Vul a.u.b. uw e-mailadres in.');
        }
        //If the email is not an email
        else if(!emailRegex.test(String(this.email.value).toLowerCase())){
            errors++;
            this.toggleError('email', 'Vul a.u.b. een geldig e-mailadres in.');
        }
        else{
            this.toggleError('email', '');
        }

        //Submit if no errors
        if(errors === 0) this.node.submit();
    };

    toggleError = (field, message) => {
        let element = this[field + 'Error'];

        if(element) {
            element.innerHTML = message;

            if (message.length > 0) {
                element.classList.remove('mod-hidden');
            }
            else {
                element.classList.add('mod-hidden');
            }
        }
    };
}

export default ArticleComments;



// WEBPACK FOOTER //
// frontend/js/components/article/ArticleComments.js